import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';

export const GET_PRESCRIPTION_LIST = '@DRUG_DESCRIPTION/GET_PRESCRIPTION_LIST';
export const GET_PRESCRIPTION_LIST_SUCCESS = '@DRUG_DESCRIPTION/GET_PRESCRIPTION_LIST_SUCCESS';
export const GET_PRESCRIPTION_LIST_FAIL = '@DRUG_DESCRIPTION/GET_PRESCRIPTION_LIST_FAIL';

export const UPDATE_PRESCRIPTION_DESCRIPTIONS = '@DRUG_DESCRIPTION/UPDATE_PRESCRIPTION_DESCRIPTIONS';
export const UPDATE_PRESCRIPTION_DESCRIPTIONS_SUCCESS = '@DRUG_DESCRIPTION/UPDATE_PRESCRIPTION_DESCRIPTIONS_SUCCESS';
export const UPDATE_PRESCRIPTION_DESCRIPTIONS_FAIL = '@DRUG_DESCRIPTION/UPDATE_PRESCRIPTION_DESCRIPTIONS_FAIL';

export const SET_DESCRIPTION_FILTER = '@DRUG_DESCRIPTION/SET_DESCRIPTION_FILTER';
export const RESET_DESCRIPTION_FILTER = '@DRUG_DESCRIPTION/RESET_DESCRIPTION_FILTER';

export const SET_SELECTED_PRESCRIPTIONS = '@DRUG_DESCRIPTION/SET_SELECTED_PRESCRIPTIONS';
export const UPDATE_PRESCRIPTION_DESCRIPTION = '@DRUG_DESCRIPTION/UPDATE_PRESCRIPTION_DESCRIPTION';

export const getPrescriptionList = (params) => {
  return (dispatch) => {
    dispatch({ type: GET_PRESCRIPTION_LIST });

    const requestBody = {
      PageIndex: params.pageIndex || 1,
      PageSize: params.pageSize || 50,
      SortField: params.SortField || 'PatientName',
      SortOrder: params.SortOrder || 1,
      PatientGroupIds: params.PatientGroupIds || [],
      PatientIds: params.PatientIds || [],
      PackingStatus: params.PackingStatus || [],
      PackType: params.PackType || [],
    };

    HttpService.post('/api/prescriptions/list', requestBody)
      .then((resp) => {
        dispatch({
          type: GET_PRESCRIPTION_LIST_SUCCESS,
          payload: { data: resp.data, total: resp.total },
        });
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: GET_PRESCRIPTION_LIST_FAIL, payload: { message: errorMessages.join('\n') } });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const updatePrescriptionDescriptions = (descriptions) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PRESCRIPTION_DESCRIPTIONS });

    HttpService.put('/api/prescriptions/descriptions', { items: descriptions })
      .then((resp) => {
        dispatch({
          type: UPDATE_PRESCRIPTION_DESCRIPTIONS_SUCCESS,
          payload: resp.data,
        });
        dispatch(
          AppActions.showMessage({
            message: 'drug:UPDATE_DESCRIPTIONS_SUCCESS',
          }),
        );
      })
      .catch((err) => {
        const { errorMessages, errorTitle } = parseError(err);
        dispatch({ type: UPDATE_PRESCRIPTION_DESCRIPTIONS_FAIL, payload: { message: errorMessages.join('\n') } });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const setDescriptionFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: SET_DESCRIPTION_FILTER, payload: { filter } });
  };
};

export const resetDescriptionFilter = () => {
  return (dispatch) => {
    dispatch({ type: RESET_DESCRIPTION_FILTER });
  };
};

export const setSelectedPrescriptions = (selectedIds) => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_PRESCRIPTIONS, payload: { selectedIds } });
  };
};

export const updatePrescriptionDescription = (prescriptionId, description) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PRESCRIPTION_DESCRIPTION,
      payload: { prescriptionId, description },
    });
  };
};